module.exports = __webpack_public_path__ + "static/media/gift-list4-active.35b55750.png";